import axios from '@/plugins/axios'
import constants from '@/services/constants'

const treasureHuntApiEndPoint = 'admin/treasure-hunt'

export default {
    namespaced: true,

    state: {
        treasures: [],
        total: 0
    },

    getters: {
        getTreasureById: state => id => {
            const treasure = state.treasures.find(treasure => treasure.id === id)
            if (treasure) {
                return JSON.parse(JSON.stringify(treasure))
            }

            return null
        }
    },

    mutations: {
        setTreasures (state, treasures) {
            state.treasures = treasures
        }
    },

    actions: {
        async fetchTreasures (context) {
            const response = await axios.get(`${treasureHuntApiEndPoint}/treasures/${constants.api.TREASURE_HUNT_GAME_TYPE}`)
            const treasures = response
            context.commit('setTreasures', treasures)
        },

        async updateTreasure (context, payload) {
            const { id, ...updateDict } = payload
            await axios.patch(`${treasureHuntApiEndPoint}/treasure/${id}`, updateDict)
            await context.dispatch('fetchTreasures')
        },

        async getTreasureHuntGameById (context, payload) {
            const { gameId } = payload
            const response = await axios.get(`${treasureHuntApiEndPoint}/game/${gameId}`)
            return response
        },

        async redeemTreasure (context, payload) {
            const { gameId } = payload
            await axios.patch(`${treasureHuntApiEndPoint}/redeem/${gameId}`, {})
        }
    }
}
